import classnames from "classnames";
import "./HistoricalLeaderboard.css";
import { ScoreInfo, PlayerInfo } from "./common/Info";
import { useAppSelector } from "./store";
import { useState, useEffect } from "react";
import star from "./assets/star.svg";

type HistoricalLeaderboardProp = {
  enabled: boolean;
  hideModal: Function;
};

function HistoricalLeaderboard({
  enabled,
  hideModal,
}: HistoricalLeaderboardProp) {
  const scores = useAppSelector((state) => {
    return state.historicLeaderboard;
  });
  const players = useAppSelector((state) => {
    return state.endGameLeaderboard.players;
  });
  const game = useAppSelector((state) => {
    return state.game;
  });

  function isCurrentScore(score: ScoreInfo): boolean {
    if (game.id !== score.gameID) {
      return false;
    }

    const result = players.find((player) => {
      return score.playerID === player.id;
    });

    if (result) {
      return true;
    } else {
      return false;
    }
  }

  const modalClasses = classnames(
    "historicalLeaderboardModalContainer",
    "centerContainer",
    {
      hidden: !enabled,
    },
  );

  const highScoreRows = scores.highScores.map((score) => {
    const isCurrent = isCurrentScore(score) ? (
      <img className="currentImg" src={star} />
    ) : (
      <span></span>
    );
    return (
      <tr key={`${score.playerID}:${score.gameID}`}>
        <td className="historicLeaderboard">
          {isCurrent}
          {score.playerName}
        </td>
        <td className="historicLeaderboard">{score.score}</td>
        <td className="historicLeaderboard">{score.turns}</td>
      </tr>
    );
  });

  const lowScoreRows = scores.lowScores.map((score) => {
    const isCurrent = isCurrentScore(score) ? (
      <img className="currentImg" src={star} />
    ) : (
      <span></span>
    );
    return (
      <tr key={`${score.playerID}:${score.gameID}`}>
        <td className="historicLeaderboard">
          {isCurrent}
          {score.playerName}
        </td>
        <td className="historicLeaderboard">{score.score}</td>
        <td className="historicLeaderboard">{score.turns}</td>
      </tr>
    );
  });

  return (
    <div className={modalClasses}>
      <div className="historicalLeaderBoardModal">
        <div className="tableContainer">
          <div className="highScores">
            <h2>High Scores</h2>
            <table className="scoreTable">
              <thead>
                <tr>
                  <th className="historicLeaderboard">Name</th>
                  <th className="historicLeaderboard">Score</th>
                  <th className="historicLeaderboard"># of turns</th>
                </tr>
              </thead>
              <tbody>{highScoreRows}</tbody>
            </table>
          </div>
          <div className="lowScores">
            <h2>Low Scores</h2>
            <table className="scoreTable">
              <thead>
                <tr>
                  <th className="historicLeaderboard">Name</th>
                  <th className="historicLeaderboard">Score</th>
                  <th className="historicLeaderboard"># of turns</th>
                </tr>
              </thead>
              <tbody>{lowScoreRows}</tbody>
            </table>
          </div>
        </div>
        <button className="primaryButton" onClick={() => hideModal()}>
          Close
        </button>
      </div>
      <div className="leaderboardOverlay" />
    </div>
  );
}

export default HistoricalLeaderboard;
